export function parseJsonInput(raw) {
  const fence = String.fromCharCode(96, 96, 96);
  let cleaned = raw.trim();
  if (cleaned.startsWith(fence + 'json')) cleaned = cleaned.slice(7).trim();
  else if (cleaned.startsWith(fence)) cleaned = cleaned.slice(3).trim();
  if (cleaned.endsWith(fence)) cleaned = cleaned.slice(0, -3).trim();
  return JSON.parse(cleaned);
}
export function formatPercent(value) { return Math.round(value || 0) + '%'; }
